import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';
import RootWrapper from 'Layouts/RootWrapper';
import SignUpSecondStep from 'Pages/Auth/SignUp/SignUpSecondStep';

import BaseRoutes from './BaseRoutes';
import CustomRedirect from './CustomRedirect';

const ActivateTrialRoutes = createBrowserRouter([
  {
    path: '/',
    element: <RootWrapper />,
    children: [
      {
        index: true,
        element: <CustomRedirect to={AuthorizedRoutePaths.ACTIVATE_TRIAL} isAuth />,
      },
      ...BaseRoutes,
      { path: AuthorizedRoutePaths.ACTIVATE_TRIAL, element: <SignUpSecondStep /> },
      {
        path: '*',
        element: <CustomRedirect to={AuthorizedRoutePaths.ACTIVATE_TRIAL} isAuth />,
      },
    ],
  },
]);

export default ActivateTrialRoutes;
